import React, { useState } from "react";
import "./gallery.css";
import photo1 from "../../assets/images/gallery1.jpg";
import photo2 from "../../assets/images/gallery2.jpg";
import photo3 from "../../assets/images/gallery3.jpg";
import photo4 from "../../assets/images/gallery4.jpg";
import photo5 from "../../assets/images/gallery5.jpg";
import photo6 from "../../assets/images/DJI_0563.jpg";
import photo7 from "../../assets/images/gallery7.jpg";
import photo8 from "../../assets/images/gallery8.jpg";
import photo9 from "../../assets/images/DJI_0564.jpg";
import photo10 from "../../assets/images/gallery10.jpg";
import photo11 from "../../assets/images/gallery11.jpg";
import photo12 from "../../assets/images/gallery12.jpg";
import { useTranslation } from "../../shared/LanguageContext";


const images = [photo10, photo11, photo12, photo1, photo2, photo3, photo9, photo5, photo6, photo8, photo7, photo4];

const Gallery = () => {
    const [modal, setModal] = useState(false);
    const [activeImg, setActiveImg] = useState(null);
    const { t } = useTranslation();

    const openModal = (img) => {
        setActiveImg(img);
        setModal(true);
    };

    const closeModal = () => {
        setModal(false);
        setActiveImg(null);
    };

    return (
        <section className="gallery-section" id="gallery">
            <div className="gallery-title">
                <h3>{t("gallery_title")}</h3>
                <p>{t("gallery_desc")}</p>
            </div>
            <div className="gallery-grid">
                {images.map((img, idx) => (
                    <div key={idx} className="gallery-item" onClick={() => openModal(img)}>
                        <img src={img} alt={`Фото ${idx + 1}`} loading="lazy" />
                    </div>
                ))}
            </div>

            {/* Модалка увеличения */}
            {modal && (
                <div className="gallery-modal" onClick={closeModal}>
                    <div className="gallery-modal-content" onClick={e => e.stopPropagation()}>
                        <img src={activeImg} alt="Фото крупно" />
                        <button className="gallery-modal-close" onClick={closeModal}>&times;</button>
                    </div>
                </div>
            )}
        </section>
    );
};

export default Gallery;
